<template>
    <div class="empty-message">
        <IconVera class="empty-message__icon" />
        {{ text }}
        <button v-if="textButton" class="empty-message__button button" @click="onSetInterests">
            {{ textButton }}
        </button>
    </div>
</template>

<script>
import IconVera from '@/views/track/icons/IconVera.vue';

export default {
    name: 'EmptyMessage',
    components: {
        IconVera,
    },
    props: {
        text: {
            type: String,
            default: '',
        },
        textButton: {
            type: String,
            default: '',
        },
    },
    methods: {
        onSetInterests() {
            this.$emit('onButton');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.empty-message {
    padding-top: urem(24);
    padding-bottom: urem(24);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 400;
    font-size: urem(16);
    line-height: urem(24);
    text-align: center;
    color: #98a0a9;
    text-wrap: balance;

    @include on-desktop {
        display: block;
        font-size: urem(16);
        color: rgba(42, 38, 38, 1);
        background: rgba(247, 249, 252, 1);
        padding: urem(12) urem(20);
        line-height: urem(24);
        border-radius: urem(10);
        border-radius: urem(16);
        text-align: left;
    }

    &__icon {
        width: urem(130);
        height: urem(116);
        margin-bottom: urem(24);

        @include on-desktop {
            display: none;
        }
    }

    &__button {
        margin-top: urem(24);
        width: 100%;
        font-size: urem(14);
        font-weight: 600;
        background-color: rgba(70, 99, 171, 1);
        line-height: urem(20);
        color: white;
        border: none;
        border-radius: urem(10);
        padding: urem(11) urem(24);
        font-family: $font-montserrat;
        cursor: pointer;
    }
}
</style>
